import React from "react";

/**
 * FormHeader Component
 *
 * Displays the main heading for each form step.
 *
 * @param {string} title - The heading text to display
 */
const FormHeader = ({ title }) => {
  return (
    <h1
      style={{
        fontSize: "24px",
        fontWeight: "500",
        color: "#1a1a1a",
        marginBottom: "40px",
        textAlign: "center",
        letterSpacing: "-0.01em",
      }}
    >
      {title}
    </h1>
  );
};

export default FormHeader;
